import { Text } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import styles from "./Header.module.scss";

interface IHeader {
  title: string;
  onClose: () => void;
}

const Header = ({ title, onClose }: IHeader) => {
  return (
    <div className={styles.header}>
      <Text className={styles.header_text}>{title}</Text>
      <IconX size={16} onClick={onClose} cursor="pointer" />
    </div>
  );
};

export default Header;
